import type { IndicatorType } from '@/service/vpc/types/IAftermarketCampaign';

export const getVariant = (type: IndicatorType) => {
  switch (type) {
    case 'Recall':
      return 'error';
    case 'Quality':
      return 'warning';
    case 'Service':
      return 'neutral';
    case 'Installation':
      return 'info';
    default:
      return 'neutral';
  }
};

export const getSubtleVariant = (type: IndicatorType) => {
  switch (type) {
    case 'Recall':
      return 'error-subtle';
    case 'Quality':
      return 'warning-subtle';
    case 'Service':
      return 'neutral-subtle';
    case 'Installation':
      return 'info-subtle';
    default:
      return 'neutral-subtle';
  }
};

// "error" | "warning" | "neutral" | "info" | "neutral-subtle" | "error-subtle" | "warning-subtle" | "success" |
// "success-subtle" | "info-subtle" | "category-1" | "category-2" | "category-3" | "category-4" | "category-5" | "category-6" |
